import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as _ from "lodash";
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  standalone: false,
  name: 'planningPackagesWeightPipe'
})
export class PlanningPackagesWeightPipe implements PipeTransform {

  constructor(@Inject(TranslateService) private translateService: TranslateService, @Inject('splitService') private splitService) {}

  transform(packages, enableUnitDisplay?: boolean, enableUnitShortDisplay?: boolean,   defaultValue?): unknown {
    let weight = 0;

    if (packages?.length) {
      weight = _.reduce(packages, function (sum, p) {
        return sum + _.get(p, 'weight', 0);
      }, 0);
    }

    let weightUnit;
    if (!!enableUnitDisplay || !!enableUnitShortDisplay) {
      const siteUnit = enableUnitShortDisplay ? this.splitService.getShortWeightUnit() : this.splitService.getWeightUnit();
      weightUnit = this.translateService.instant(`WEIGHT_UNIT.${siteUnit}`);
    }

    return (weight).toFixed(Number.isInteger(weight) ? 0 : 2) + ((!!enableUnitDisplay || !!enableUnitShortDisplay) ? (' ' + weightUnit) : '');

  }

}
